const colors = {
  completedBorder: '#0078d4',
  completedIcon: '#0078d4',
  inProgressIcon: '#c0def6',
  incompleteBorder: '#ebebeb',
  incompleteIcon: '#edebe9',

  background: '#fff',
  stepContentBorder: '#e1dfdd',
  subtitle: '#605E5C',
  title: '#323130',
};

export function smartShoppingStyles({ palette }) {
  return {
    '&>.page-content': {
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'stretch',
      '& .bidding-strategy__container': {
        '& .custom-param__key-field': {
          display: 'inline-block',
          width: '85px',
          'margin-left': '5px',
          'margin-right': '5px',
        },
        '& #currencyLabelTargetCpa': {
          display: 'inline-block',
          'vertical-align': 'initial',
          marginTop: 0,
        },
        '& #currencyLabelTargetRoas': {
          display: 'inline-block',
          'vertical-align': 'initial',
          marginTop: 0,
        },
        '& a.helpbutton': {
          'margin-left': '5px',
        },
        '& .alert': {
          marginTop: 6,
          marginLeft: 0,
          '& .alert-image': {
            height: 16,
            paddingTop: 0,
          },
        },
        '& .checkbox': {
          '& label': {
            display: 'flex',
            alignItems: 'flex-start',
            '& [type=checkbox]': {
              order: -1,
              display: 'block',
              marginRight: 8,
            },
          },
        },
      },
    },
    '& .progress-list': {
      minWidth: 248,
      width: 248,
      borderRight: `1px solid ${colors.stepContentBorder}`,
      marginLeft: '38px',

      '& ol.step-progress-list': {
        margin: 0,
        padding: 0,
        listStyle: 'none',
      },

      '& ol.step-progress-list>.step-progress-list-item': {
        paddingTop: '24px',

        '&:first-child': {
          borderLeftColor: colors.background,
        },

        '&>.step-progress-list-item-glyphicon': {
          marginLeft: '-8px',
          marginRight: '8px',
          background: colors.background,
          paddingTop: '5px',
          paddingBottom: '4px',
        },
      },

      '& .step-progress-list-item': {
        borderLeft: `2px solid ${colors.completedBorder}`,
        '&.step-progress-list-item-ahead': { borderLeftColor: colors.incompleteBorder },
      },

      '& .step-progress-list-item-behind .step-progress-list-item-glyphicon': {
        color: colors.completedIcon,
      },

      '& .step-progress-list-item-selected .step-progress-list-item-glyphicon': {
        color: colors.inProgressIcon,
      },

      '& .step-progress-list-item-ahead .step-progress-list-item-glyphicon': {
        color: colors.incompleteIcon,
      },
    },
    '& .sub-form': {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      '&>.form-content': {
        flex: 1,
      },
      '&>.bottom-bar': {
        borderTop: `1px solid ${palette.neutralLight}`,
        padding: '0 32px',
        height: 64,
        display: 'flex',
        alignItems: 'center',
        '&>.ssc-form-next': {
          marginRight: 54,
          '&.first-step': {
            marginRight: 12,
          },
        },
        '&>.ssc-form-back': {
          marginRight: 12,
        },
      },
      '& .adschedule-targets-container': {
        borderTop: 'none',
        '& .form-group': {
          '& .col-sm-2, & .col-sm-10': {
            paddingLeft: 0,
          },
        },
      },
    },
    '& .smart-shopping-campaign-settings': {
      '& .header-section': {
        marginLeft: 32,
        '&>p': {
          color: palette.neutralSecondary,
        },
      },
      '& .ba-backbone-instance-wrapper>div': {
        paddingTop: 0,
      },
      '& .advanced-scheduling-grid': {
        '& .alert': {
          margin: 0,
          lineHeight: '16px',
        },
      },
    },
    '& .crud-audience-ad': {
      '&>a.HelpTopic, &>span': {
        display: 'inline-block',
        lineHeight: '21px',
        verticalAlign: 'middle',
      },
      '&>a.HelpTopic': {
        marginLeft: 5,
      },
      '& .audience-ads-policy-container .alert.alert-info': {
        lineHeight: '16px',
        marginTop: 0,
        marginLeft: 0,
        '& .alert-info-inline': {
          '& a': {
            verticalAlign: 'middle',
          },
        },
        '& .alert-image': {
          marginTop: 2,
        },
      },
      '& .react-image-experience': {
        '& .advanced-url-options': {
          '& .col-sm-8 .row': {
            height: 35,
          },
          '& .upgraded-url-options-preview__value': {
            marginTop: 2,
          },
          '& .control-label': {
            marginTop: 0,
          },
          '& input.form-control.custom-param__key-field': {
            margin: '0 5px',
          },
          '& input.form-control.custom-param__value-field': {
            marginLeft: 5,
          },
          '& .tracking-template__container .charactersRemaining span': {
            wordBreak: 'break-all',
          },
          '& .row': {
            minHeight: 35,
            marginTop: 10,
          },
          '& .upgraded-url-options-preview__label': {
            'white-space': 'nowrap',
          },
        },
        '& .impression-tracking-urls': {
          '& .form-group .row': {
            display: 'block',
          },
        },
      },
    },
    '& .location-manage': {
      '& .location-popup-editor .ba-backbone-instance-wrapper>div': {
        padding: 0,
      },
    },
    '& .feed-filter__container': {
      marginTop: 33,
    },
  };
}
